import React from 'react';

type Props = {
  state?: any;
};

/**
 * Badge d'état : vert + ✓ si 100 % complété et tout valide,
 * sinon décompte « X ✓ - Y ✗ / Z ».
 */
const ChecklistBadge = ({ state }: Props) => {
  if (!state) {
    return null;
  }
  if (state.total === 0) {
    return <span className="checklist_badge checklist_badge_empty">No question</span>;
  }
  const success = state.isComplete && state.isAllValid;
  return (
    <span className={`checklist_badge ${success ? 'checklist_badge_ok' : 'checklist_badge_warn'}`}>
      {success ? '✓ ' : ''}
      {state.valid} ✓ - {state.invalid} ✗ / {state.total}
    </span>
  );
};

export default ChecklistBadge;
